import { useState } from "react";
import type { Campaign } from "../../../mocks/campaigns";

interface VenueCampaignBannerProps {
  campaign: Campaign;
}

export default function VenueCampaignBanner({ campaign }: VenueCampaignBannerProps) {
  const [copied, setCopied] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(campaign.couponCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200">
      {/* Discount badge */}
      <div className="absolute top-0 right-0 bg-amber-500 text-white text-xs font-bold px-4 py-2 rounded-bl-2xl rounded-tr-2xl">
        %{campaign.discountPct} İNDİRİM
      </div>

      <div className="flex flex-col md:flex-row gap-4 p-5 md:p-6">
        {/* Image */}
        <div className="w-full md:w-48 h-36 rounded-xl overflow-hidden flex-shrink-0">
          <img
            src={campaign.image}
            alt={campaign.title}
            className="w-full h-full object-cover object-top"
          />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <i className="ri-coupon-line text-amber-600 text-base" />
            <span className="text-xs font-semibold text-amber-700 uppercase tracking-wider">Aktif Kampanya</span>
          </div>
          <h3 className="text-stone-800 font-bold text-lg mb-1.5">{campaign.title}</h3>
          <p className={`text-stone-600 text-sm leading-relaxed ${!expanded ? "line-clamp-2" : ""}`}>
            {campaign.description}
          </p>
          {campaign.description.length > 80 && (
            <button
              onClick={() => setExpanded(!expanded)}
              className="text-amber-600 text-xs font-medium mt-1 hover:underline cursor-pointer"
            >
              {expanded ? "Daha az göster" : "Devamını oku"}
            </button>
          )}

          {/* Expiry */}
          <div className="flex items-center gap-1.5 mt-2">
            <i className="ri-time-line text-stone-400 text-sm" />
            <span className="text-xs text-stone-500">Son geçerlilik: <strong>{campaign.expiresDate}</strong></span>
          </div>
        </div>

        {/* Coupon code */}
        <div className="flex flex-col items-center justify-center gap-3 flex-shrink-0">
          <div className="border-2 border-dashed border-amber-400 rounded-xl px-6 py-3 bg-white text-center">
            <div className="text-xs text-stone-500 mb-1">Kupon Kodu</div>
            <div className="text-xl font-bold tracking-widest text-stone-800">{campaign.couponCode}</div>
          </div>
          <button
            onClick={handleCopy}
            className={`w-full flex items-center justify-center gap-2 rounded-xl py-2.5 text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
              copied
                ? "bg-emerald-600 text-white"
                : "bg-amber-500 hover:bg-amber-600 text-white"
            }`}
          >
            <i className={`${copied ? "ri-check-line" : "ri-file-copy-line"} text-base`} />
            {copied ? "Kopyalandı!" : "Kodu Kopyala"}
          </button>
        </div>
      </div>
    </div>
  );
}
